import { Component, inject, signal } from '@angular/core';
import { ScreenNavigationService } from '../../core/services/screen-navigation';
import { ThemeCatalogService } from '../../core/services/theme-catalog';
import { GameSessionService } from '../../core/services/game-session';
import { ThemePicker } from '../../shared/components/theme-picker/theme-picker';
import { PageLoader } from '../../shared/components/page-loader/page-loader';
import { AlertModal } from '../../shared/components/alert-modal/alert-modal';
import { apiErrorDetail } from '../../core/models/responses/api-error-response';
import { Theme } from '../../core/models/responses/theme';

const START_ERROR_MESSAGE = 'Não foi possível iniciar o jogo. Tente novamente.';

/** Escolha de tema do Modo Solo: ao escolher, inicia a sessão e vai para o jogo. */
@Component({
  selector: 'app-theme',
  imports: [ThemePicker, PageLoader, AlertModal],
  templateUrl: './theme.html',
  styleUrl: './theme.scss',
})
export class ThemePage {
  private readonly screenNavigation = inject(ScreenNavigationService);
  private readonly themeCatalog = inject(ThemeCatalogService);
  private readonly gameSession = inject(GameSessionService);
  protected readonly themes = signal<Theme[]>([]);
  protected readonly isLoadingThemes = signal(true);
  protected readonly isStartingSession = signal(false);
  protected readonly errorMessage = signal<string | null>(null);

  ngOnInit(): void {
    this.themeCatalog.loadQuemSouEu().subscribe({
      next: (themes) => {
        this.themes.set(themes);
        this.isLoadingThemes.set(false);
      },
      error: (error: unknown) => {
        console.error('Não foi possível carregar os temas.', error);
        this.isLoadingThemes.set(false);
      },
    });
  }

  protected onBackClick(): void {
    this.screenNavigation.goToHome();
  }

  protected onThemeClick(theme: Theme): void {
    if (this.isStartingSession()) {
      return;
    }

    this.isStartingSession.set(true);
    // Em caso de sucesso o loading permanece até a troca de tela,
    // evitando que a lista de temas reapareça por um instante antes do game-screen.
    this.gameSession
      .start(theme.id)
      .then(() => this.screenNavigation.goToGame(theme))
      .catch((error: unknown) => {
        console.error('Não foi possível iniciar a sessão.', error);
        this.isStartingSession.set(false);
        // Ex.: 400 "O tema não existe" quando o tema não pertence ao jogo.
        this.errorMessage.set(apiErrorDetail(error) ?? START_ERROR_MESSAGE);
      });
  }
}
